// extracted by mini-css-extract-plugin
export default {"buttons":"PaymentForm_buttons__M+3T0 t-20 b-20","myAccountButtonsContainerInner":"PaymentForm_myAccountButtonsContainerInner__GuQK-"};